import { styled } from "theme/default/styled";

export const SToastClose = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;
